// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".intro_detail_wrap {\n  padding-top: 1px !important;\n  min-height: calc(100vh - 235px) !important; }\n  .intro_detail_wrap .select_wrap {\n    padding: 0.5rem; }\n  .intro_detail_wrap .drawing_section .content_wrap .file_view iframe {\n    display: block;\n    width: 100%;\n    height: calc(100vh - 100px - 54px) !important; }\n    @media (max-width: 768px) {\n      .intro_detail_wrap .drawing_section .content_wrap .file_view iframe {\n        height: calc(100vh - 54px - 54px) !important; } }\n", ""]);
// Exports
module.exports = exports;



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader/dist/cjs.js!../node_modules/sass-loader/lib/loader.js!./Src/Containers/Intro/IntroDetailPage.scss
// module id = 2403
// module chunks = 1